import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-712be128")

_pushScopeId("data-v-712be128")
const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { id: "session-expiry-background" }
const _hoisted_3 = { id: "session-expiry" }
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      id: "app-layout",
      innerHTML: _ctx.appLayout
    }, null, 8, ["innerHTML"]),
    _withDirectives(_createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("p", null, [
          _createTextVNode("Your session has expired. Please select \"Renew Session\" to continue working on " + _toDisplayString(_ctx.title) + ".", 1),
          _hoisted_4,
          _createTextVNode(" As per " + _toDisplayString(_ctx.readableSsoType) + " authentication refresh period, you may be prompted to login through your user credentials. ", 1)
        ]),
        _createVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.renewSession && _ctx.renewSession(...args)))
        }, "Renew Session")
      ])
    ], 512), [
      [_vShow, _ctx.showSessionExpiry]
    ])
  ]))
})